export class ReducerRegistry {
    constructor() {
        this.persistBlacklistedDynamicReducers = [];
        this.changeListeners = {};
        this.reducers = {};
        this.dynamicReducers = {};
    }
    getReducers() {
        return Object.assign({}, this.reducers);
    }
    getDynamicReducers() {
        return Object.assign({}, this.dynamicReducers);
    }
    register(name, reducer, skipIfExists = false) {
        if (skipIfExists && this.reducers.hasOwnProperty(name))
            return this;
        this.reducers = Object.assign(Object.assign({}, this.reducers), { [name]: reducer });
        Object.keys(this.changeListeners).forEach((key) => {
            this.changeListeners[key](this.getReducers(), this.getDynamicReducers(), this.persistBlacklistedDynamicReducers);
        });
        return this;
    }
    registerDynamic(name, reducer, skipIfExists = false, shouldPersist = true) {
        if (skipIfExists && this.dynamicReducers.hasOwnProperty(name))
            return this;
        this.dynamicReducers[name] = reducer;
        if (!shouldPersist)
            this.persistBlacklistedDynamicReducers.push(name);
        Object.keys(this.changeListeners).forEach((key) => {
            this.changeListeners[key](this.getReducers(), this.getDynamicReducers(), this.persistBlacklistedDynamicReducers);
        });
        return this;
    }
    exists(reducerName) {
        return (this.reducers.hasOwnProperty(reducerName) ||
            this.dynamicReducers.hasOwnProperty(reducerName));
    }
    addChangeListener(name, fn) {
        this.changeListeners[name] = fn;
        return this;
    }
    removeChangeListener(name) {
        delete this.changeListeners[name];
        return this;
    }
}
//# sourceMappingURL=ReducerRegistry.js.map